/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S31_Item_2Inputs */

const es_privacy_policy_data_collected_s31_item_2 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificador unico de usuario del proveedor (ID de Google, ID de Microsoft, etc.)`)
};

const en_privacy_policy_data_collected_s31_item_2 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unique user identifier from the provider (Google ID, Microsoft ID, etc.)`)
};

/**
* | output |
* | --- |
* | "Unique user identifier from the provider (Google ID, Microsoft ID, etc.)" |
*
* @param {Privacy_Policy_Data_Collected_S31_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s31_item_2 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S31_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S31_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s31_item_2(inputs)
	return en_privacy_policy_data_collected_s31_item_2(inputs)
});
export { privacy_policy_data_collected_s31_item_2 as "privacy_policy.data_collected.s31_item_2" }